<div class="sidenav-container" [class.sidenav-is-mobile]="isMobile()">
  @if (toolbar()) {
  <mat-toolbar class="sidenav-toolbar">
    <!-- BOTON MENU -->
    <div class="sidenav-toolbar__start">
      @if (showMenuButton()) {
      <button mat-icon-button (click)="alternarMenu()" class="sidenav-toolbar__menu-btn" aria-label="Botón sidenav">
        <mat-icon class="sidenav-toolbar__icon">
          {{ abierto() ? 'close' : 'menu' }}
        </mat-icon>
      </button>
      }
      <div class="sidenav-toolbar__logo" [appOpenInNewTab]="'/inicio'" role="img" aria-label="Work logo"></div>
    </div>
    <!-- DESPLEGABLE USUARIO -->
    <div class="sidenav-toolbar__end">
      <ng-container *transloco="let translate; read: 'sidenav-profile'">
        <div class="sidenav-toolbar__user-info">
          <div class="sidenav-toolbar__user-details">
            <span class="sidenav-toolbar__user-name">{{ entorno() }} / {{ dusuario() }}</span>
            <span class="sidenav-toolbar__user-role">{{ descnivelportal() }}</span>
          </div>
          <!-- Agrupado con las acciones del final, no con la navegación del inicio:
               en mobile el lado izquierdo queda solo con el menú. -->
          @if (showDashboardButton()) {
          <button mat-icon-button class="sidenav-toolbar__dashboard-btn" [appOpenInNewTab]="'/inicio'"
            [matTooltip]="translate('application')" [attr.aria-label]="translate('application')">
            <mat-icon class="sidenav-toolbar__icon">apps</mat-icon>
          </button>
          }
          <button mat-icon-button [matMenuTriggerFor]="matMenu" aria-label="Abrir menú de opciones"
            class="sidenav-toolbar__dropdown-btn">
            <mat-icon class="sidenav-toolbar__icon">arrow_drop_down</mat-icon>
          </button>
        </div>
        <mat-menu #matMenu="matMenu" xPosition="before">
          <button mat-menu-item [routerLink]="['/inicio']">
            <mat-icon>apps</mat-icon>
            <span>{{ translate("application") }}</span>
          </button>
          <button mat-menu-item [routerLink]="['/settings']">
            <mat-icon>settings</mat-icon>
            <span>{{ translate("settings") }}</span>
          </button>
          <button mat-menu-item [routerLink]="['/ayuda']">
            <mat-icon>help_outline</mat-icon>
            <span>{{ translate("help") }}</span>
          </button>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span>{{ translate("logout") }}</span>
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </mat-toolbar>
  }
  <mat-sidenav-container class="sidenav-body">
    <mat-sidenav [mode]="isMobile() ? 'over' : 'side'" [(opened)]="abierto" class="mat-elevation-z2">
      <mat-nav-list>
        <tree-menu [dataMenuTree]="routesTreeData()"></tree-menu>
      </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content>
      <ng-content></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>